export default {
  transparent: true,
  depthTest: true,
  depthWrite: false,

  vertexShader: `
    #define PI 3.1415926535897932384626433832795

    precision highp float;

    attribute vec3 instanceFrom;
    attribute vec3 instanceTo;
    attribute float opacity;
    attribute float width;

    varying vec3 vColor;
    varying float vOpacity;

    float atan2(in float y, in float x)
    {
      return x == 0.0 ? sign(y) * PI / 2.0 : atan(y, x);
    }
    
    void main() {
      float dx = instanceTo.x - instanceFrom.x;
      float dy = instanceTo.y - instanceFrom.y;
      float d = length(instanceTo - instanceFrom);

      float rad = PI - atan(
        instanceTo.x - instanceFrom.x,
        instanceTo.y - instanceFrom.y
      );
      float s = sin(rad);
      float c = cos(rad);

      mat4 s_matrix = mat4(
        width, 0.0, 0.0, 0.0,
        0.0,  d, 0.0, 0.0,
        0.0, 0.0, 1.0, 0.0,
        0.0, 0.0, 0.0, 1.0
      );

      mat4 r_matrix = mat4(
          c,  -s, 0.0, 0.0,
          s,   c, 0.0, 0.0,
        0.0, 0.0, 1.0, 0.0,
        0.0, 0.0, 0.0, 1.0
      );
      mat4 t_matrix = mat4(
        1.0, 0.0, 0.0, instanceFrom.x + (dx * 0.5),
        0.0, 1.0, 0.0, instanceFrom.y + (dy * 0.5),
        0.0, 0.0, 1.0, instanceFrom.z,
        0.0, 0.0, 0.0, 1.0
      );

      vec4 mvPosition = modelViewMatrix * vec4( vec3(0.0, 0.0, 0.0), 1.0 ) * t_matrix;
      mvPosition += vec4(position, 1.0) * s_matrix * r_matrix;
      gl_Position = projectionMatrix * mvPosition;

      vOpacity = opacity;
    }
  `,

  fragmentShader: `
    precision highp float;

    varying float vOpacity;

    void main() {

      if (vOpacity < 0.05) {
        discard;
      }

      gl_FragColor = vec4( 1.0, 1.0, 1.0, vOpacity);
    }
  `
}
